/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "Admin";
    UserRole["Collector"] = "Collector";
    UserRole["Technician"] = "Technician";
    UserRole["Renter"] = "Renter";
})(UserRole || (UserRole = {}));
export function UserRoleFromJSON(json) {
    return UserRoleFromJSONTyped(json, false);
}
export function UserRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UserRoleToJSON(value) {
    return value;
}
